import { alpha } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import type { SxProps } from '@mui/system';

export function getDockPillSx(overrides?: SxProps<Theme>): SxProps<Theme> {
  return {
    background: (theme: Theme) => {
      const color = theme.palette.primary.main;
      return [
        `linear-gradient(135deg, ${alpha(color, 0.28)} 0%, ${alpha(color, 0.16)} 50%, ${alpha(color, 0.06)} 100%)`,
        'white',
      ].join(', ');
    },
    borderRadius: 4,
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    ...overrides,
  };
}
